<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Products Category</h5>
                </div>
                <div class="card-body">

                    <div class="add-product">
                        <form class="needs-validation" #categoryForm="ngForm" (ngSubmit)="onSubmit(categoryForm)">
                            <div class="form">
                                <div class="form-group">
                                    <label for="validationCustom01" class="mb-1">EN Description:</label>
                                    <input class="form-control" id="validationCustom01" type="text"
                                        [(ngModel)]="Category.description" name="Description">
                                </div>
                                <div class="form-group">
                                    <label for="validationCustom01" class="mb-1">FR Description :</label>
                                    <input class="form-control" id="validationCustom01" type="text"
                                        [(ngModel)]="Category.fr_description" name="Fr_Description">
                                </div>
                                <div class="form-group">
                                    <label for="validationCustom01" class="mb-1">ES Description :</label>
                                    <input class="form-control" id="validationCustom01" type="text"
                                        [(ngModel)]="Category.es_description" name="ES_Description">
                                </div>
                                <div class="form-group">
                                    <label for="validationCustom01" class="mb-1">Category Title :</label>
                                    <input class="form-control" id="validationCustom01" type="text"
                                        [(ngModel)]="Category.category_title" name="category_title">
                                </div>
                                <div class="form-group">
                                    <label for="validationCustom01" class="mb-1">ES Category Title :</label>
                                    <input class="form-control" id="validationCustom01" type="text"
                                        [(ngModel)]="Category.es_category_title" name="es_category_title">
                                </div>
                                <div class="form-group">
                                    <label for="validationCustom01" class="mb-1">FR Category Title :</label>
                                    <input class="form-control" id="validationCustom01" type="text"
                                        [(ngModel)]="Category.fr_category_title" name="fr_category_title">
                                </div>
                       
                                <div>
                                    <label for="validationCustom01" class="mb-1">EN Detail</label>
                                    <textarea class="form-control" id="validationCustom01" [(ngModel)]="Category.detail" name="detail"
                                        rows="4">
                                </textarea>
                                </div>
                                <div>
                                    <label for="validationCustom01" class="mb-1"> FR Detail</label>
                                    <textarea class="form-control" id="validationCustom01" [(ngModel)]="Category.fr_detail" name="fr_detail"
                                        rows="4">
                                </textarea>
                                </div>
                                <div>
                                    <label for="validationCustom01" class="mb-1">ES Detail</label>
                                    <textarea class="form-control" id="validationCustom01" [(ngModel)]="Category.es_detail" name="es_detail"
                                        rows="4">
                                </textarea>
                                </div>
                                <div class="form-group mb-0">
                                    <label for="validationCustom02" class="mb-1">Category Image :</label>
                                    <input class="form-control" id="validationCustom02" type="file" [(ngModel)]="Category.categoryimages" name="img_category" (change)="onImageSelected($event)">
                                </div>
                            </div>
                        <button type="button" type="submit" class="btn btn-primary">Add Category</button>
                        </form>
                    </div>
                </div>
                <div id="batchDelete" class="category-table custom-datatable">
                    <div class="table-responsive">
                        <ng2-smart-table [settings]="settings" [source]="Source" (editConfirm)="updateRecord($event)"
                            (deleteConfirm)="deleteRecord($event)"></ng2-smart-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->